module.exports = __webpack_public_path__ + "static/media/bg-header-all.e07cacdb.png";